<div class="container" [ngClass]="positionClass">
  <div class="containerClass"><div><img [src]="icon" [alt]="fareName"></div>
    <div class="m-fare"><img [src]="fareImage" [alt]="fareName"></div></div>
  <div><button class="btnBenefits" (click)="openBenefits()">{{'seatReview.faresDesc.btnBenefit' | translate}}</button></div>
</div>
